import api from "./api";

interface ILogIn {
  email: string;
  password: string;
}

const UsersService = {
  create: async (body: any) =>
    await api.post("/api/user/onboarding/register", { ...body }),

  criarPixAutomatico: async (body: any) =>
    await api.post("/api/user/onboarding/register/pix_automatico", { ...body }),

  consultarStatusPixAutomatico: async (codigoTransacao: string) =>
    await api.post("/api/user/onboarding/register/pix_automatico/status", {
      transaction_code: codigoTransacao,
    }),
};

export default UsersService;
